module.exports = __webpack_public_path__ + "static/1-0eb1314c679be597fc15c7d934eaff77.jpg";